import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface ButtonProps extends Omit<MuiButtonProps, 'size'> {
  size?: 'small' | 'medium' | 'large' | 'icon';
}

const sizeStyles = {
  small: 'h-8 px-3 text-sm',
  medium: 'h-10 px-4 py-2',
  large: 'h-12 px-8',
  icon: 'p-0',
} as const;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'contained', size = 'icon', className = '', ...props }, ref) => {
    return (
      <MuiButton
        ref={ref}
        variant={variant}
        className={cn(
          // Base styles
          'inline-flex items-center justify-center rounded-md transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          'disabled:pointer-events-none disabled:opacity-50',
          // Apply size styles
          sizeStyles[size],
          className
        )}
        disableRipple
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';